import { render, staticRenderFns } from "./_achievement.vue?vue&type=template&id=bd3fefe2&"
import script from "./_achievement.vue?vue&type=script&lang=js&"
export * from "./_achievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports